var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card-container',{attrs:{"blank":_vm.blank}},[(_vm.loading)?_c('div',{class:_vm.$style.loading},[_c('icon',{attrs:{"icon":"innovatie"}}),_vm._v(" Loading... ")],1):_vm._e(),(!_vm.loading)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.mediaItem.htmlContent)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }